// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBYl9e9FS5pIp38jA_wE-sGWjZi27LT660",
  authDomain: "eat-coast-5f37d.firebaseapp.com",
  projectId: "eat-coast-5f37d",
  storageBucket: "eat-coast-5f37d.appspot.com",
  messagingSenderId: "734184082448",
  appId: "1:734184082448:web:e1edf7e3515c8917db0e95"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const authentication = getAuth(app);